
import DoughnutLabel from "chartjs-plugin-doughnutlabel-v3";
import { Doughnut } from 'react-chartjs-2'
import {
    Chart,
    DoughnutController,
    registerables
} from "chart.js";
import { useTranslation } from 'react-i18next';
import { isIterableArray, pluginDoughnutBg, toFormatPrice, toStringPrice } from '../../../utils/utils';
import { Typography } from "@material-tailwind/react";
import { classCharDoughnutContainerHeight, } from "../common";
Chart.register(
    ...registerables,
    DoughnutController,
    DoughnutLabel,
);

const EMPTY_SEGMENT_COLOR = '#fff'

const PieGraph = ({ currentData, originData, isEmpty, isMobile, graphId, getCalculateResult, compareFunction }) => {

    const { t } = useTranslation()

    const options = {
        plugins: {
            tooltip: {
                backgroundColor: '#fff',
                bodyColor: '#444248',
                titleColor: '#444248',
                titleSpacing: 8,
                caretSize: 0,
                cornerRadius: 12,
                borderColor: '#EDEDED',
                borderWidth: 2,
                // displayColors: false,
                padding: 16,
                titleFont: {
                    size: 18
                },
                bodyFont: {
                    size: 18
                },
                filter: function (context) {
                    return context.dataset?.tooltips?.[context?.dataIndex]
                },
                callbacks: {
                    title: function (tooltipItems) {
                        return ''
                    },
                    label: function (context) {
                        let label = context.dataset.label[context.dataIndex] ? context.dataset.label[context.dataIndex] : '';
                        if (isIterableArray(context.dataset?.dataOrigin)) {
                            if (label) {
                                label += ': ';
                            }
                            label += toStringPrice(context.dataset?.dataOrigin[context.dataIndex]);
                            return label;
                        }
                        if (context.formattedValue) {
                            if (label) {
                                label += ': ';
                            }
                            label += context.formattedValue;
                        }
                        return label;
                    },
                    labelColor: function (context) {
                        return {
                            backgroundColor: context.dataset.backgroundColor[context.dataIndex],
                            border: 0,
                            boxWidth: 10,
                            boxHeight: 10,
                            pointStyle: 'circle',
                            useBorderRadius: true,
                            borderRadius: 8,
                        }
                    }
                }
            },
            legend: {
                display: false,
                position: 'bottom',
                align: 'center',
            },
            datalabels: {
                formatter: function (value) {
                    return `${toFormatPrice(value, 3)}`;
                },
                color: function (c) {
                    if (c.dataset.backgroundColor[c.dataIndex] === '#444248') return '#fff'
                    if (c.dataset.backgroundColor[c.dataIndex] === EMPTY_SEGMENT_COLOR) return EMPTY_SEGMENT_COLOR
                    return '#444248';
                },
                font: {
                    weight: 500,
                    size: isMobile ? 9 : 12,
                    family: 'Inter'
                }
            },
            doughnutLabel: {
                labels: [
                    {
                        text: t('analytics.declared'),
                        font: {
                            size: isMobile ? "9" : '12',
                            family: "Inter",
                            weight: "400",
                            lineHeight: 1
                        },
                        color: "#767579",
                    },
                    {
                        text: toStringPrice(originData.declared) + ' ' + t('mvHour'),
                        font: {
                            size: isMobile ? "11" : '14',
                            family: "Inter",
                            weight: "400",
                            lineHeight: 3,
                        },
                        color: "#2D2B32",
                    },
                    {
                        text: t('analytics.delta_cons'),
                        font: {
                            size: isMobile ? "9" : '12',
                            family: "Inter",
                            weight: "400",
                            lineHeight: 2
                        },
                        color: "#2D2B32",
                    },
                    {
                        text: toStringPrice(originData.delta_cons) + ' ' + t('mvHour'),
                        font: {
                            size: isMobile ? "11" : '14',
                            family: "Inter",
                            weight: "400",
                            lineHeight: 1.2
                        },
                        color: "#EF4444",
                    },
                    {
                        text: t('analytics.fact'),
                        font: {
                            size: isMobile ? "9" : '12',
                            family: "Inter",
                            weight: "400",
                            lineHeight: 3
                        },
                        color: "#767579",
                    },
                    {
                        text: toStringPrice(originData.fact) + ' ' + t('mvHour'),
                        font: {
                            size: isMobile ? "11" : '14',
                            family: "Inter",
                            weight: "400",
                            lineHeight: 1
                        },
                        color: "#2D2B32",
                    },
                    {
                        text: getCalculateResult(currentData.compareValues1, currentData.compareValues2, compareFunction(currentData.compareValues1, currentData.compareValues2)),
                        font: {
                            size: isMobile ? '9' : "12",
                            family: "Inter",
                            weight: "700",
                            lineHeight: 3
                        },
                        color: "#a546a2"
                    },
                ]
            }
        }
    }

    // план  #444248
    // факт C4B5FD
    // minus  F87171
    // plus 73CD88

    const dataset = originData.declared > originData.fact ?
        [
            {
                label: [t('analytics.declared'), t('analytics.delta_cons')],
                backgroundColor: ['#444248', '#F87171'],
                hoverBackgroundColor: ['#444248', '#F87171'],
                data: [currentData?.values?.declared - currentData?.values?.delta_cons, currentData?.values?.delta_cons],
                dataOrigin: [currentData?.values?.declared, currentData?.values?.delta_cons],
                tooltips: [true, true],
                borderWidth: 0,
            },
            {
                label: [t('analytics.fact'), ''],
                backgroundColor: ['#C4B5FD', EMPTY_SEGMENT_COLOR],
                hoverBackgroundColor: ['#C4B5FD', EMPTY_SEGMENT_COLOR],
                data: [currentData?.values?.fact, currentData?.values?.delta_cons],
                tooltips: [true, false],
                borderWidth: 0,
            },
        ] : [
            {
                label: [t('analytics.declared'), t('analytics.delta_cons')],
                backgroundColor: ['#444248', '#F87171'],
                data: [currentData?.values?.declared, currentData?.values?.delta_cons],
                borderWidth: 0,
            },
            {
                label: [t('analytics.fact'), t('analytics.delta_cons')],
                backgroundColor: ['#C4B5FD', '#F87171'],
                data: [currentData?.values?.fact,],
                borderWidth: 0,
            },

        ]


    const data = {
        labels: originData.declared > originData.fact ? [t('analytics.declared'), t('analytics.delta_cons'), t('analytics.fact'), ''] : [t('analytics.declared'), t('analytics.delta_cons'), '', t('analytics.fact')],
        datasets: dataset,
        doughnutlabel: {
            display: true,
        }
    };


    return (
        <>
            {
                isEmpty ?
                    <div className={`flex items-center justify-center ${classCharDoughnutContainerHeight}`}>
                        <Typography variant='lead' className='text-[16px] lap:text-[20px] font-medium text-center my-[40px]'>
                            {t('analytics.month_detailing_no_data')}
                        </Typography>
                    </div>
                    :
                    <Doughnut
                        id={graphId}
                        updateMode='resize'
                        data={data}
                        options={options}
                        plugins={[pluginDoughnutBg]}
                    />
            }
        </>
    )
}

export default PieGraph